const AbiBillingAdminApiUrls = {
  GET: `${process.env.REACT_APP_USER_ABI_URL}/abi/billing/admin/get`,
};

export default AbiBillingAdminApiUrls;
